export const weatherApiBaseUrl = 'https://api.openweathermap.org/data/2.5/weather';
export const weatherApiKey = 'e51a99ba5449d1c13ee0227cdc604c58';
export const mapBaseUrl = 'https://raw.githubusercontent.com/djaiss/mapsicon/33ba28808f8d32b5bae0ffada9cadd07073852e1/all/';
export const countryApi = 'https://restcountries.com/v3.1/region/';
